import { financesCovered, toggleFinancesCovered } from './financesCovered'

// The chrome's half of the curtain: the button in the header (see
// shared/_app_header) and the keystroke that does the same thing without one.
//
// Which icon is showing is CSS's job, from [data-money] on <html> — see
// application.css. Only aria-pressed has to be written, because there is no
// attribute selector that can tell a screen reader anything.
//
// ⌘⇧P — free in Chrome and Safari on macOS, where ⌘P prints and ⌘⇧M switches
// profile. Ctrl on everything else. Not a bare key however fast that would be:
// this app is full of text fields, and a curtain that fell every time somebody
// typed a letter in a project title would be turned off within the hour.
const KEY = 'p'

export function initFinanceCover() {
  // Delegated, and on document: the header is data-turbo-permanent in places
  // and re-rendered in others, and a listener bound to the button itself would
  // be bound to whichever button existed when the session started.
  document.addEventListener('click', (event) => {
    const button = (event.target as HTMLElement | null)?.closest?.('[data-finance-cover]')
    if (!button) return

    event.preventDefault()
    void toggleFinancesCovered()
  })

  document.addEventListener('keydown', (event) => {
    if (event.key.toLowerCase() !== KEY) return
    if (!(event.metaKey || event.ctrlKey) || !event.shiftKey) return

    event.preventDefault()
    void toggleFinancesCovered()
  })

  // One observer for the attribute rather than writing aria-pressed at each
  // call site: the curtain can also move from the keystroke, from another tab's
  // Turbo visit rendering a fresh header, or from the server disagreeing with
  // an optimistic flip. All of them end at [data-money], so watch that.
  const observer = new MutationObserver(reflect)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-money'] })

  document.addEventListener('turbo:load', reflect)
  reflect()
}

function reflect() {
  const covered = financesCovered()

  document.querySelectorAll('[data-finance-cover]').forEach((button) => {
    button.setAttribute('aria-pressed', String(covered))
    // The label says what pressing it will do, which is the opposite of what
    // is true now — a button announced as "cover amounts" while everything is
    // already covered is a button nobody can tell the state of by ear.
    button.setAttribute('aria-label', covered ? 'Show amounts' : 'Cover amounts')
    button.setAttribute('title', covered ? 'Show amounts (⌘⇧P)' : 'Cover amounts (⌘⇧P)')
  })
}
